import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";
import SysProdutoAutocomplete from "@/components/utils/crud/SysProdutoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysStatusProduto from "@/components/utils/crud/SysStatusProduto.vue";
import SysAutocomplete from "@/components/utils/crud/SysAutocomplete.vue";
import Grid from "@/components/Diagnostico/CurvasCruzadas/IndicadorEvolucao/Grid";
import Chart from "@/components/Diagnostico/CurvasCruzadas/IndicadorEvolucao/Chart";
import Filtros from "@/components/Diagnostico/utils/Filtros";
import MovimentacaoEstoque from "@/components/Diagnostico/SlowNoMoving/MovimentacaoEstoque/Index.vue";
import SysMarcaAutocomplete from "@/components/utils/crud/SysMarcaAutocomplete.vue";

export const componentes = {
  MovimentacaoEstoque,
  DivisorComLegenda,
  TextoOutrosFiltrosSelecionadosAutocomplete,
  SysProdutoAutocomplete,
  SysFornecedorAutocomplete,
  SysCompradorAutocomplete,
  SysSegmentoAutocomplete,
  SysMarcaAutocomplete,
  SysStatusProduto,
  SysAutocomplete,
  Grid,
  Chart,
  Filtros
}
